import React from "react";
// import "./BackButton.css"
import { useNavigate } from "react-router-dom";

const BackButton = ({ target, setFunction, value, className }) => {
	const navigate = useNavigate();
	return (
		<div
			className={`h-3 cursor-pointer ${className}`}
			onClick={() => {
				if (target !== false) {
					navigate(target);
				} else {
					setFunction(value);
				}
			}}
		>
			<img
				className="h-full w-auto object-contain"
				src={require("../../images/backButton.png")}
				alt="back-button"
			/>
		</div>
	);
};

export default BackButton;
